<template>
    <section class="blog-posts bg-white">
        <div class="section-title">
            <h2>آخرین اخبار</h2>
            <p>آخرین اخبار رامنیک را از این بخش دنبال کنید</p>
        </div>
        <div class="w-100">
            <div class="col-12 col-md-6 col-lg-4 mt-4"
                 v-for="blogPost in blogPosts">
                <div class="icon-box">
                    <h4>{{ blogPost.name }}</h4>
                    <p v-html="blogPost.caption"></p>
                    <div class="col-12 text-left">
                        <router-link :to="{ name: 'content', params: { slug: blogPost.slug.replace(/ /gi, '-') }}">مشاهده بیشتر</router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center mt-5">
                <router-link class="link-more text-dark" :to="{ name: 'blog' }">مشاهده همه اخبار</router-link>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            rootImagePath: {
                type: String
            },

            blogPosts: {
                type: Array
            }
        }
    };
</script>
<style scoped>
    .slider,
    .slider .item,
    .slider .slider-bg {
        width: 100%;
        float: left;
        height: 400px;
    }

    .slider {
        padding: 0 !important;
    }

        .slider .item,
        .slider .slider-bg {
            overflow: hidden;
        }

        .slider .slider-bg {
            background-position: top center;
            background-size: cover;
            animation-duration: 8s;
            animation-timing-function: linear;
        }

            .slider .slider-bg::after {
                content: "";
                width: 100%;
                height: 400px;
                position: absolute;
                top: 0;
                left: 0;
                background: #292929;
                opacity: 0.7;
            }

        .slider h1 {
            position: relative;
            top: -100px;
            text-align: center;
            color: #ddd;
        }

    .blog-posts .icon-box {
        padding: 30px;
        background: #f8f8f8;
        transition: ease-in-out 0.3s;
        border:#ddd solid 1px;
    }

        .blog-posts .icon-box i {
            float: left;
            color: #3498db;
            font-size: 40px;
        }

        .blog-posts .icon-box h4 {
            margin-left: 70px;
            font-weight: 700;
            margin-bottom: 15px;
            font-size: 18px;
        }

            .blog-posts .icon-box h4 a {
                color: #384046;
                transition: 0.3s;
            }

        .blog-posts .icon-box p {
            margin-left: 70px;
            line-height: 24px;
            font-size: 14px;
        }

        .blog-posts .icon-box:hover {
            box-shadow: 0px 2px 22px rgba(0, 0, 0, 0.08);
        }

            .blog-posts .icon-box:hover h4 a {
                color: #3498db;
            }
</style>
